import { useCallback, useState } from "react";
import { usePermissions } from "@/hooks/use-permissions";
import {
  PIPE_FILTER_STORAGE_KEY,
  parsePipeFilter,
  type PipeFilter,
} from "@/lib/pipe-filter";

function readStored(): string | null {
  try {
    return localStorage.getItem(PIPE_FILTER_STORAGE_KEY);
  } catch {
    return null;
  }
}

/**
 * Filteret i Pipe. Husker valget per nettleser (localStorage `crm_pipe_filter`);
 * DL og admin starter på «Alle», andre på «Mine». Lagringen er en bekvemmelighet
 * og skal aldri kunne stoppe siden.
 */
export function usePipeFilter(): [PipeFilter, (patch: Partial<PipeFilter>) => void] {
  const { isAdmin } = usePermissions();
  const [filter, setFilter] = useState<PipeFilter>(() => parsePipeFilter(readStored(), isAdmin));

  const update = useCallback((patch: Partial<PipeFilter>) => {
    setFilter((current) => {
      const next = { ...current, ...patch };
      try {
        localStorage.setItem(PIPE_FILTER_STORAGE_KEY, JSON.stringify(next));
      } catch {
        // lagring er valgfri
      }
      return next;
    });
  }, []);

  return [filter, update];
}
